export default class AutoFocus {
    constructor() {
        this._zIndex = 0;
    }
    add(element) {
        element.addEventListener('mousedown', () => {
            this.raise(element);
        });
    }
    raise(element) {
        if(element.dataset.autoFocusToChildren) {
            for(const child of element.children) {
                this.raise(child);
            }
        } else {
            element.style.zIndex = ++this._zIndex;
        }
    }
}
